export default __webpack_public_path__ + "static/media/eng.0cbd5e01.png";